import { useBreakpoints } from "@/components/screen"
import WebsiteButton from "@/components/website-button/WebsiteButton"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import RightsBlock from "@/pages/website-landing/components/footer/rights-block/RightsBlock"
import { websiteRoutes } from "@/router/routes"
import { FC } from "react"
import { useNavigate } from "react-router-dom"
import "./FooterLegalNote.less"

const { Text } = WebsiteTypography
const { website } = websiteRoutes

type FooterLegalNoteProps = {
  isSingleSubmission?: boolean
  isOrgFooter?: boolean
}

const FooterLegalNote: FC<FooterLegalNoteProps> = ({ isOrgFooter, isSingleSubmission }) => {
  const navigate = useNavigate()
  const { isXxl, isXl, isLg } = useBreakpoints()

  const isDesktopFooter = isXxl || isXl || isLg

  const onPrivacyClick = () => {
    navigate(website.privacyPolicy)
  }
  const onTermsClick = () => {
    navigate(website.termsAndConditions)
  }

  return (
    <div
      className={`footer-legal-wrapper ${!isOrgFooter && !isSingleSubmission && isDesktopFooter ? "not-in-line" : ""}`}
    >
      {(isOrgFooter || isSingleSubmission || !isDesktopFooter) && <RightsBlock />}

      {(isOrgFooter || isSingleSubmission || !isDesktopFooter) && <div className={"footer-divider"} />}

      <div className={"terms-block"}>
        <WebsiteButton btnType={"text"} onClick={onTermsClick}>
          <Text color={"website-secondary"} size={"sm"}>
            {"Terms and conditions"}
          </Text>
        </WebsiteButton>
        <div className={"footer-divider"} />
        <WebsiteButton btnType={"text"} onClick={onPrivacyClick}>
          <Text color={"website-secondary"} size={"sm"}>
            {"Privacy policy"}
          </Text>
        </WebsiteButton>
      </div>

      {isDesktopFooter && !isOrgFooter && !isSingleSubmission && <RightsBlock />}
    </div>
  )
}

export default FooterLegalNote
